/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { ecosystemSlug, reactSelectStyle } from "Config/Config";

//import url and gateway methods
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";
import { consentOptions } from "helper/Common/CommonHelper";

const SaveMedicalConsent = ({ afterActionClose = () => {} }) => {
  const params = useParams();
  const token = localStorage.getItem("token"); // Get the token from local storage
  const [currentStep, setCurrentStep] = useState(1);
  const [accessType, setAccessType] = useState(null); // 'doctor' or 'clinic'
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [selectedConsent, setSelectedConsent] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [consetValue, setConsetValue] = useState(null);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [durationType, setDurationType] = useState("permanent"); // "permanent" or "temporary"
  const [consentDate, setConsentDate] = useState("");
  const [purpose, setPurpose] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [isSavingConsent, setIsSavingConsent] = useState(false);

  // Async load options for doctors
  const loadDoctorOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_GUEST_ALL_USERS +
        `?filtername=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR&ecosystemslug=${ecosystemSlug}`;

      const reponse = await getData(requestUrl);

      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  // Aasync function for clinics
  const loadClinicOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_GUEST +
        `?filtername=${inputValue}&ecosystemslug=${ecosystemSlug}`;

      console.log("requestUrl in clinic", requestUrl);
      const response = await getData(requestUrl);

      return response.data;
    } catch (error) {
      return [];
    }
  };

  //function for get default options for lab tests
  const getDefaultOptions = async (consentType = "") => {
    try {
      let requestURL = url.API_BASE_URL;
      let response = {};
      switch (consentType) {
        case "lab_tests":
          requestURL +=
            url.API_GET_MEDICAL_TEST_OPTIONS +
            `?token=${token}&istemplate=false&members=${params.id}`;
          response = await getData(requestURL);
          if (response.status) {
            const lastTenRecords = response.data.slice(0, 10);
            setDefaultOptions(lastTenRecords);
          }
          break;
        case "prescriptions":
          requestURL +=
            url.API_GET_MEDICAL_DOCUMENT_OPTIONS +
            `?token=${token}&istemplate=false&members=${params.id}`;
          response = await getData(requestURL);
          if (response.status) {
            const lastTenRecords = response.data.slice(0, 10);
            setDefaultOptions(lastTenRecords);
          }
          break;
        case "medical_condition":
          requestURL +=
            url.API_GET_MEDICAL_CONDITION_OPTIONS +
            `?token=${token}&members=${params.id}`;
          response = await getData(requestURL);
          if (response.status) {
            const lastTenRecords = response.data.slice(0, 10);
            setDefaultOptions(lastTenRecords);
          }
          break;
        case "vaccinations":
          requestURL +=
            url.API_GET_IMMUNIZATION_OPTIONS +
            `?token=${token}&members=${params.id}`;
          response = await getData(requestURL);
          if (response.status) {
            const lastTenRecords = response.data.slice(0, 10);
            setDefaultOptions(lastTenRecords);
          }
          break;
        default:
          setDefaultOptions([]);
          break;
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for load async options for consents
  const loadAsyncOptions = async (inputValue) => {
    try {
      if (selectedConsent) {
        const consentType = selectedConsent.value;
        let requestURL = url.API_BASE_URL;
        let response = {};
        switch (consentType) {
          case "lab_tests":
            requestURL +=
              url.API_GET_MEDICAL_TEST_OPTIONS +
              `?token=${token}&istemplate=false&members=${params.id}&medicaltestname=${inputValue}`;
            response = await getData(requestURL);
            if (response.status) {
              return response.data;
            }
            break;
          case "prescriptions":
            requestURL +=
              url.API_GET_MEDICAL_DOCUMENT_OPTIONS +
              `?token=${token}&istemplate=false&members=${params.id}&filtername=${inputValue}`;
            response = await getData(requestURL);
            if (response.status) {
              return response.data;
            }
            break;
          case "medical_condition":
            requestURL +=
              url.API_GET_MEDICAL_CONDITION_OPTIONS +
              `?token=${token}&members=${params.id}&filtername=${inputValue}`;
            response = await getData(requestURL);
            if (response.status) {
              return response.data;
            }
            break;
          case "vaccinations":
            requestURL +=
              url.API_GET_IMMUNIZATION_OPTIONS +
              `?token=${token}&members=${params.id}&filtertitle=${inputValue}`;
            response = await getData(requestURL);
            if (response.status) {
              return response.data;
            }
            break;
          default:
            return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.log(error.message);
      return [];
    }
  };

  //function for select consent records
  const consentRecordSelectionHandler = (val) => {
    setConsetValue(val);
    setSelectedRecords(val.map((item) => item.value));
  };

  // Reset handler
  const resetHandler = () => {
    setCurrentStep(1);
    setAccessType(null);
    setSelectedDoctor(null);
    setSelectedClinic(null);
    setSelectedConsent(null);
    setConsetValue(null);
    setSelectedRecords([]);
  };

  // Save consent handler
  const saveConsentHandler = async () => {
    try {
      const authorizedUserId = selectedDoctor
        ? selectedDoctor.value
        : selectedClinic
        ? selectedClinic.moderator
        : null;

      setIsSavingConsent(true);

      const consentPayload = {
        ownerid: params.id,
        authorizeduserid: authorizedUserId,
        healthcarefacilityid: selectedClinic ? selectedClinic.value : null,
        medicalrecordids: selectedRecords,
        recordcategory: selectedConsent ? selectedConsent?.value : "",
        ispermanent: durationType === "permanent" ? true : false,
        purpose: purpose,
        additionalinformation: additionalInfo,
      };

      if (durationType === "temporary") {
        consentPayload.expirationdate = new Date(consentDate);
      }

      console.log("consentPayload", consentPayload);

      let requestUrl =
        url.API_BASE_URL + url.API_ADD_MEDICAL_CONSENT + `?token=${token}`;
      const response = await postData(requestUrl, consentPayload);

      console.log("response in save consent", response);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveMedicalConsentOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }

      setIsSavingConsent(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (selectedConsent) {
      getDefaultOptions(selectedConsent.value);
    }
  }, [selectedConsent]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveMedicalConsentOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary icon-md">
              health_and_safety
            </span>
          </div>
          <div>
            <p
              className="offcanvas-title text-white mb-0"
              id="saveMedicalConsentOffCanvasLabel"
            >
              <span className="d-block pe-3 me-3">
                <span className="fw-bold">{currentStep}</span> of 3
              </span>
              {currentStep === 1
                ? "Grant Access to Medical Records"
                : currentStep === 2
                ? "Configure Permissions"
                : "Review and Confirm"}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      {/* Progress bar */}
      <div className="progress" style={{ height: "2px" }}>
        <div
          className="progress-bar"
          style={{ width: `${currentStep * 33.333}%` }}
        ></div>
      </div>

      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-white">
          {/* Step 1 */}
          <div className={currentStep === 1 ? "d-block" : "d-none"}>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Who do you want to grant access to?
                </label>
                <div className="d-flex gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="accessType"
                      id="doctorRadio"
                      value="doctor"
                      checked={accessType === "doctor"}
                      onChange={() => {
                        setAccessType("doctor");
                        setSelectedClinic(null);
                      }}
                    />
                    <label className="form-check-label" htmlFor="doctorRadio">
                      Doctor
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="accessType"
                      id="clinicRadio"
                      value="clinic"
                      checked={accessType === "clinic"}
                      onChange={() => {
                        setAccessType("clinic");
                        setSelectedDoctor(null);
                      }}
                    />
                    <label className="form-check-label" htmlFor="clinicRadio">
                      Clinic
                    </label>
                  </div>
                </div>
              </div>

              {/* If Doctor selected, show async select for doctor */}
              {accessType === "doctor" && (
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Select Doctor
                  </label>
                  <AsyncSelect
                    isClearable
                    name="doctorSelect"
                    loadOptions={loadDoctorOptions}
                    defaultOptions={false}
                    cacheOptions={false}
                    placeholder="Type doctor name"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={selectedDoctor}
                    onChange={setSelectedDoctor}
                  />
                </div>
              )}

              {/* If Clinic selected, show async select for clinic only */}
              {accessType === "clinic" && (
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Select Clinic
                  </label>
                  <AsyncSelect
                    isClearable
                    name="clinicSelect"
                    loadOptions={loadClinicOptions}
                    defaultOptions={false}
                    cacheOptions={false}
                    placeholder="Type clinic name"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={selectedClinic}
                    onChange={setSelectedClinic}
                  />
                </div>
              )}

              {/* If Doctor selected, show doctor details */}
              {selectedDoctor ? (
                <div className="patient-details mb-4">
                  {/* Doctor details */}
                  <div className="d-flex gap-3">
                    <div
                      className="avatar rounded-circle overflow-hidden"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <img
                        className="w-100 h-100 object-fit-cover"
                        src={
                          selectedDoctor?.userimage !== ""
                            ? url.SERVER_URL + selectedDoctor?.userimage
                            : assetImages.defaultUser
                        }
                        alt="doctor"
                      />
                    </div>
                    <div>
                      <p className="mb-0">{selectedDoctor?.label}</p>
                      <p className="font-sm text-gray mb-1">
                        Email: {selectedDoctor?.email}
                      </p>
                    </div>
                  </div>
                  <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                    <p className="fw-semibold mb-2">
                      Information for Dr. {selectedDoctor?.label}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Phone: {selectedDoctor?.phone}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      City: {selectedDoctor?.city}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      State: {selectedDoctor?.state}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Country: {selectedDoctor?.country}
                    </p>
                  </div>
                </div>
              ) : null}

              {/* If Clinic selected, show clinic details */}
              {selectedClinic ? (
                <div className="clinic-details mb-4">
                  {/* Clinic details */}
                  <div className="d-flex gap-3">
                    <div
                      className="avatar rounded-circle overflow-hidden"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <img
                        className="w-100 h-100 object-fit-cover"
                        src={
                          selectedClinic?.logo !== ""
                            ? url.SERVER_URL + selectedClinic?.logo
                            : assetImages.defaultUser
                        }
                        alt="clinic"
                      />
                    </div>
                    <div>
                      <p className="mb-0">{selectedClinic?.label}</p>
                      <p className="font-sm text-gray mb-1">
                        Owner: {selectedClinic?.moderatorname}
                      </p>
                    </div>
                  </div>
                  <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                    <p className="fw-semibold mb-2">
                      Information for Clinic {selectedClinic?.label}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Phone: {selectedClinic?.phone}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      City: {selectedClinic?.city}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      State: {selectedClinic?.state}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Country: {selectedClinic?.country}
                    </p>
                  </div>
                </div>
              ) : null}

              {/* Next button */}
              <div className="group_btnOuter d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={() => setCurrentStep(2)}
                  disabled={
                    (accessType === "doctor" && !selectedDoctor) ||
                    (accessType === "clinic" && !selectedClinic)
                  }
                >
                  Next Step
                  <span className="material-symbols-outlined">
                    chevron_right
                  </span>
                </button>
              </div>
            </form>
          </div>

          {/* Step 2 and 3 placeholders */}
          <div className={currentStep === 2 ? "d-block" : "d-none"}>
            {/* Show selected doctor or clinic name */}
            <div className="mb-4">
              {accessType === "doctor" && selectedDoctor && (
                <div className="fw-bold fs-5 text-primary">
                  Granting consent to Dr. {selectedDoctor?.label}
                </div>
              )}
              {accessType === "clinic" && selectedClinic && (
                <div className="fw-bold fs-5 text-primary">
                  Granting consent to Clinic {selectedClinic?.label}
                </div>
              )}
            </div>

            {/* Consent type select */}
            <div className="mb-4">
              <label className="fw-semibold mb-2">Select Consent Type</label>
              <Select
                options={consentOptions}
                value={selectedConsent}
                onChange={(val) => {
                  if (val) {
                    setSelectedConsent(val);
                    setConsetValue(null);
                    setSelectedRecords([]);
                  } else {
                    setSelectedConsent(null);
                    setConsetValue(null);
                    setSelectedRecords([]);
                  }
                }}
                isClearable
                placeholder="Choose consent type"
                styles={reactSelectStyle("3px", "6px", true, false)}
              />
            </div>

            {/* Placeholder for associated async select */}
            {selectedConsent && (
              <div className="mb-4">
                <label className="fw-semibold mb-2">
                  Select {selectedConsent.label}
                </label>
                {/* Placeholder for async select */}
                <AsyncSelect
                  isMulti
                  loadOptions={loadAsyncOptions}
                  defaultOptions={defaultOptions}
                  cacheOptions={true}
                  placeholder={`Type to search ${selectedConsent.label}`}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={consetValue}
                  onChange={consentRecordSelectionHandler}
                />
                {/* Render consent label and selected items with serial numbers */}
                {consetValue && consetValue.length > 0 && (
                  <div className="mt-4">
                    <div
                      className="fw-bold mb-2"
                      style={{ fontSize: "1.1rem" }}
                    >
                      Added Consent: {selectedConsent.label}
                    </div>
                    <ul className="list-unstyled mb-0">
                      {consetValue.map((item, idx) => (
                        <li
                          key={item.value}
                          className="d-flex align-items-center mb-2"
                        >
                          <span className="me-2 text-primary fw-semibold">
                            {idx + 1}.
                          </span>
                          <span
                            className="badge rounded-pill bg-primary text-white px-3 py-2"
                            style={{ fontSize: "1rem", letterSpacing: "0.5px" }}
                          >
                            {item.label}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}

            {/* Next and Previous buttons */}
            <div className="group_btnOuter d-flex justify-content-between pt-3">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => setCurrentStep(1)}
              >
                Previous Step
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={
                  !selectedConsent || !consetValue || consetValue.length === 0
                }
                onClick={() => {
                  if (
                    selectedConsent &&
                    consetValue &&
                    consetValue.length > 0
                  ) {
                    setCurrentStep(3);
                  }
                }}
              >
                Next Step
              </button>
            </div>
          </div>

          {/* Step 3 - Review and Confirm */}
          <div className={currentStep === 3 ? "d-block" : "d-none"}>
            {/* Consent summary section */}
            <div className="mb-4 p-4 rounded-10 bg-danger-subtle border border-gray-300">
              <div className="fw-bold mb-2" style={{ fontSize: "1.2rem" }}>
                Consent: {selectedConsent?.label}
              </div>
              <ul className="list-unstyled mb-0">
                {consetValue &&
                  consetValue.map((item, idx) => (
                    <li
                      key={item.value}
                      className="d-flex align-items-center mb-2"
                    >
                      <span className="me-2 text-primary fw-semibold">
                        {idx + 1}.
                      </span>
                      <span
                        className="badge rounded-pill bg-primary text-white px-3 py-2"
                        style={{
                          fontSize: "1rem",
                          letterSpacing: "0.5px",
                          background: "#2563eb",
                        }}
                      >
                        {item.label}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>

            {/* Duration section */}
            <div className="mb-4">
              <label className="fw-semibold mb-2 d-block">Duration</label>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className={`btn w-50 ${
                    durationType === "permanent"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setDurationType("permanent")}
                >
                  Permanent
                </button>
                <button
                  type="button"
                  className={`btn w-50 ${
                    durationType === "temporary"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setDurationType("temporary")}
                >
                  Temporary
                </button>
              </div>
            </div>

            {/* Form section */}
            <div className="mb-4">
              <div
                className={
                  durationType === "temporary" ? "form-group mb-3" : "d-none"
                }
              >
                <label className="fw-semibold mb-2 d-block">Date</label>
                <input
                  type="date"
                  className="form-control shadow-none border border-gray-300"
                  value={consentDate}
                  onChange={(e) => setConsentDate(e.target.value)}
                />
              </div>
              <div className="form-group mb-3">
                <label className="fw-semibold mb-2 d-block">Purpose</label>
                <textarea
                  className="form-control shadow-none border border-gray-300"
                  rows={2}
                  value={purpose}
                  onChange={(e) => setPurpose(e.target.value)}
                  placeholder="Enter purpose"
                />
              </div>
              <div className="form-group mb-3">
                <label className="fw-semibold mb-2 d-block">
                  Additional Information (optional)
                </label>
                <textarea
                  className="form-control shadow-none border border-gray-300"
                  rows={2}
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                  placeholder="Enter additional information"
                />
              </div>
            </div>

            <div
              className={`group_btnOuter d-flex pt-3 ${
                isSavingConsent
                  ? "justify-content-end"
                  : "justify-content-between"
              }`}
            >
              {!isSavingConsent && (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setCurrentStep(2)}
                >
                  Previous Step
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={!purpose || isSavingConsent}
                onClick={saveConsentHandler}
              >
                {isSavingConsent ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  "Save Consent"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveMedicalConsent;
